import { QuickActionCard } from "@/components/atoms/modernise-with-ai/QuickActionCard";
import { Plus, Upload } from "lucide-react";

interface QuickActionsSectionProps {
  onActionClick: (actionId: "request" | "error") => void;
}

const quickActions = [
  {
    id: "request" as const,
    title: "Request New Tool",
    description: "Need a custom modernization tool for your org?",
    icon: Plus,
    color: "from-green-500 to-emerald-600",
  },
  {
    id: "error" as const,
    title: "Salesforce Error Analysis",
    description: "Upload error emails for AI analysis",
    icon: Upload,
    color: "from-red-500 to-orange-600",
  },
];

export const QuickActionsSection: React.FC<QuickActionsSectionProps> = ({
  onActionClick,
}) => (
  <div className="mb-6">
    <h2 className="text-lg font-semibold mb-3">Quick Actions</h2>
    <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-6">
      {quickActions.map((action) => (
        <QuickActionCard
          key={action.id}
          {...action}
          onClick={() => onActionClick(action.id)}
        />
      ))}
    </div>
  </div>
);
